module.exports = `${require.publicPath}icon-128x128.3107ae3f.png`;